var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("div", { staticClass: "main-content" }, [
      _c("div", { staticClass: "main-content-inner" }, [
        _vm._m(0),
        _vm._v(" "),
        _vm._m(1),
        _vm._v(" "),
        _c("div", { staticClass: "page-content" }, [
          _c("div", { staticClass: "tab-content" }, [
            _c("div", { staticClass: "row" }, [
              _c("div", { staticClass: "col-xs-12" }, [
                _vm.error
                  ? _c("div", { staticClass: "alert alert-danger" }, [
                      _vm._v(
                        "\n                " +
                          _vm._s(_vm.message) +
                          "\n              "
                      )
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _vm.sucessStatus
                  ? _c("div", { staticClass: "alert alert-success" }, [
                      _vm._v(
                        "\n                " +
                          _vm._s(_vm.message) +
                          "\n              "
                      )
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _c("p", [
                  _vm._v(
                    "\n                現在のログインパスワードと、新しいログインパスワードを入力してください。\n              "
                  )
                ]),
                _vm._v(" "),
                _c("h3", [_vm._v("ログインパスワードを変更する ：")]),
                _vm._v(" "),
                _c(
                  "form",
                  {
                    staticClass: "UserChanegePassword",
                    on: {
                      submit: function($event) {
                        $event.preventDefault()
                        _vm.validateBeforeSubmit($event)
                      }
                    }
                  },
                  [
                    _c("ul", { staticClass: "none-list" }, [
                      _c("li", [
                        _c("label", { staticClass: "clearfix" }, [
                          _c(
                            "span",
                            {
                              directives: [
                                {
                                  name: "show",
                                  rawName: "v-show",
                                  value: _vm.errors.has("oldPassword"),
                                  expression: "errors.has('oldPassword')"
                                }
                              ],
                              staticClass: "block error"
                            },
                            [_vm._v(_vm._s(_vm.errors.first("oldPassword")))]
                          ),
                          _vm._v(" "),
                          _c("span", { staticClass: "label_title" }, [
                            _vm._v("現在のパスワード")
                          ]),
                          _vm._v(" "),
                          _c(
                            "span",
                            { staticClass: "input-icon input-icon-right" },
                            [
                              _c("input", {
                                directives: [
                                  {
                                    name: "validate",
                                    rawName: "v-validate",
                                    value: "required",
                                    expression: "'required'"
                                  },
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: _vm.credentials.oldPassword,
                                    expression: "credentials.oldPassword"
                                  }
                                ],
                                staticClass: "form-control",
                                class: { error: _vm.errors.has("oldPassword") },
                                attrs: {
                                  id: "oldPassword",
                                  name: "oldPassword",
                                  type: "password",
                                  placeholder: "現在のパスワード"
                                },
                                domProps: {
                                  value: _vm.credentials.oldPassword
                                },
                                on: {
                                  input: function($event) {
                                    if ($event.target.composing) {
                                      return
                                    }
                                    _vm.$set(
                                      _vm.credentials,
                                      "oldPassword",
                                      $event.target.value
                                    )
                                  }
                                }
                              }),
                              _vm._v(" "),
                              _c("i", { staticClass: "ace-icon fa fa-lock" })
                            ]
                          )
                        ]),
                        _vm._v(" "),
                        _c("span", { staticClass: "oldpassword-showhide" }, [
                          _c(
                            "span",
                            {
                              staticClass: "show-password",
                              on: {
                                click: function($event) {
                                  _vm.showhidePassword(
                                    "oldPassword",
                                    "show-password",
                                    "oldpassword-showhide"
                                  )
                                }
                              }
                            },
                            [
                              _c("img", {
                                attrs: {
                                  src: require("../../../static/img/eye_off.png"),
                                  width: "30"
                                }
                              })
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "span",
                            {
                              staticClass: "hide-password",
                              on: {
                                click: function($event) {
                                  _vm.showhidePassword(
                                    "oldPassword",
                                    "hide-password",
                                    "oldpassword-showhide"
                                  )
                                }
                              }
                            },
                            [
                              _c("img", {
                                attrs: {
                                  src: require("../../../static/img/eye_on.png"),
                                  width: "30"
                                }
                              })
                            ]
                          )
                        ])
                      ]),
                      _vm._v(" "),
                      _c("li", [
                        _c("span", {
                          staticClass: "error_m block error",
                          attrs: { id: "passworderror" }
                        }),
                        _vm._v(" "),
                        _c("label", { staticClass: "clearfix" }, [
                          _c(
                            "span",
                            {
                              directives: [
                                {
                                  name: "show",
                                  rawName: "v-show",
                                  value: _vm.errors.has("newPassword"),
                                  expression: "errors.has('newPassword')"
                                }
                              ],
                              staticClass: "block error"
                            },
                            [_vm._v(_vm._s(_vm.errors.first("newPassword")))]
                          ),
                          _vm._v(" "),
                          _c("span", { staticClass: "label_title" }, [
                            _vm._v("新しいパスワード")
                          ]),
                          _vm._v(" "),
                          _c(
                            "span",
                            { staticClass: "input-icon input-icon-right" },
                            [
                              _c("input", {
                                directives: [
                                  {
                                    name: "validate",
                                    rawName: "v-validate",
                                    value: "required",
                                    expression: "'required'"
                                  },
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: _vm.credentials.newPassword,
                                    expression: "credentials.newPassword"
                                  }
                                ],
                                staticClass: "form-control",
                                class: { error: _vm.errors.has("newPassword") },
                                attrs: {
                                  id: "newPassword",
                                  name: "newPassword",
                                  type: "password",
                                  placeholder: "新しいパスワード"
                                },
                                domProps: {
                                  value: _vm.credentials.newPassword
                                },
                                on: {
                                  input: function($event) {
                                    if ($event.target.composing) {
                                      return
                                    }
                                    _vm.$set(
                                      _vm.credentials,
                                      "newPassword",
                                      $event.target.value
                                    )
                                  }
                                }
                              }),
                              _vm._v(" "),
                              _c("i", { staticClass: "ace-icon fa fa-lock" })
                            ]
                          )
                        ]),
                        _vm._v(" "),
                        _c("span", { staticClass: "newpassword-showhide" }, [
                          _c(
                            "span",
                            {
                              staticClass: "show-password",
                              on: {
                                click: function($event) {
                                  _vm.showhidePassword(
                                    "newPassword",
                                    "show-password",
                                    "newpassword-showhide"
                                  )
                                }
                              }
                            },
                            [
                              _c("img", {
                                attrs: {
                                  src: require("../../../static/img/eye_off.png"),
                                  width: "30"
                                }
                              })
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "span",
                            {
                              staticClass: "hide-password",
                              on: {
                                click: function($event) {
                                  _vm.showhidePassword(
                                    "newPassword",
                                    "hide-password",
                                    "newpassword-showhide"
                                  )
                                }
                              }
                            },
                            [
                              _c("img", {
                                attrs: {
                                  src: require("../../../static/img/eye_on.png"),
                                  width: "30"
                                }
                              })
                            ]
                          )
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "note" }, [
                          _vm._v(
                            "\n                    半角英大文字・半角英小文字・数字を組み合わせた8文字以上\n                  "
                          )
                        ])
                      ]),
                      _vm._v(" "),
                      _c("li", [
                        _c("label", { staticClass: "clearfix" }, [
                          _c("span", { staticClass: "label_title" }, [
                            _vm._v("新しいパスワード再入力")
                          ]),
                          _vm._v(" "),
                          _c(
                            "span",
                            { staticClass: "input-icon input-icon-right" },
                            [
                              _c("input", {
                                directives: [
                                  { name: "validate", rawName: "v-validate" },
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: _vm.credentials.confirmnewPassword,
                                    expression: "credentials.confirmnewPassword"
                                  }
                                ],
                                staticClass: "block form-control",
                                class: { error: _vm.errors.has("newPassword") },
                                attrs: {
                                  name: "newPassword",
                                  id: "confirmnewPassword",
                                  "data-vv-rules":
                                    "required|confirmed:newPassword",
                                  type: "password",
                                  placeholder: "新しいパスワード再入力"
                                },
                                domProps: {
                                  value: _vm.credentials.confirmnewPassword
                                },
                                on: {
                                  input: function($event) {
                                    if ($event.target.composing) {
                                      return
                                    }
                                    _vm.$set(
                                      _vm.credentials,
                                      "confirmnewPassword",
                                      $event.target.value
                                    )
                                  }
                                }
                              }),
                              _vm._v(" "),
                              _c("i", { staticClass: "ace-icon fa fa-lock" })
                            ]
                          )
                        ]),
                        _vm._v(" "),
                        _c(
                          "span",
                          { staticClass: "confirm-password-showhide" },
                          [
                            _c(
                              "span",
                              {
                                staticClass: "show-password",
                                on: {
                                  click: function($event) {
                                    _vm.showhidePassword(
                                      "confirmnewPassword",
                                      "show-password",
                                      "confirm-password-showhide"
                                    )
                                  }
                                }
                              },
                              [
                                _c("img", {
                                  attrs: {
                                    src: require("../../../static/img/eye_off.png"),
                                    width: "30"
                                  }
                                })
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "span",
                              {
                                staticClass: "hide-password",
                                on: {
                                  click: function($event) {
                                    _vm.showhidePassword(
                                      "confirmnewPassword",
                                      "hide-password",
                                      "confirm-password-showhide"
                                    )
                                  }
                                }
                              },
                              [
                                _c("img", {
                                  attrs: {
                                    src: require("../../../static/img/eye_on.png"),
                                    width: "30"
                                  }
                                })
                              ]
                            )
                          ]
                        )
                      ]),
                      _vm._v(" "),
                      _vm._m(2)
                    ])
                  ]
                )
              ])
            ])
          ])
        ])
      ])
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      {
        staticClass: "breadcrumbs ace-save-state",
        attrs: { id: "breadcrumbs" }
      },
      [
        _c("ul", { staticClass: "breadcrumb" }, [
          _c("li", [
            _c("i", { staticClass: "ace-icon fa fa-home home-icon" }),
            _vm._v(" "),
            _c("a", { attrs: { href: "#/" } }, [_vm._v("メインメニュー")])
          ]),
          _vm._v(" "),
          _c("li", { staticClass: "active" }, [_vm._v("パスワード変更")])
        ])
      ]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "page-header" }, [
      _c("div", { staticClass: "checkbox" }, [
        _c("h3", [_vm._v("パスワード変更")])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "clearfix" }, [
      _c("button", { staticClass: "btn btn-info", attrs: { type: "submit" } }, [
        _vm._v("\n                    パスワードを変更\n                    ")
      ])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-be39fc60", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-be39fc60","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/user/UserChangePassword.vue
// module id = null
// module chunks = 